export default __webpack_public_path__ + "static/media/default_profile.12ea4f36.png";